import {Navigate} from 'react-router-dom';
import {usePermissions} from "../../../modules/auth/authorization/PermissionProvider";

type RedirectEntry = {
    permission: string;
    path: string;
};

type Props = {
    redirects: RedirectEntry[];
    fallbackPath?: string;
};

/**
 * Navigue vers le premier itinéraire autorisé en fonction des autorisations utilisateur.
 * Si aucune correspondance n'est trouvée, la redirection se fait vers un chemin de secours.
 *
 * @param {Object} props - Props object containing redirects and fallbackPath
 * @param {Array.<Object>} props.redirects - List of route configurations with permissions
 * @param {string} props.fallbackPath - Path to redirect if no allowed route is found
 * @returns {JSX.Element} - React element for navigation
 */
const NavigateToFirstAllowedRoute = ({redirects, fallbackPath = '/error/401'}: Props): JSX.Element => {
    const userPermissions = usePermissions();

    const firstMatch = redirects.find(entry =>
        userPermissions.includes(entry.permission)
    );

    return <Navigate to={firstMatch?.path || fallbackPath} replace/>;
};

export default NavigateToFirstAllowedRoute;